export const MasterData = [
    {
      id: "1",
      enable:1,
      code: "M001",
      category: "MC001",
      name: "Replaced new digital thermostat",
      price: "77,990.00",
      unit: "NOs",
      createdBy: "Admin 01",
      createdDate: "2025/01/01",
    },
    {
        id: "2",
        enable:1,
        code: "M002",
        category: "MC001",
        name: "Re-wired low volt in to new one",
        price: "3,120.00",
        unit: "NOs",
        createdBy: "Admin 02",
        createdDate: "2024/12/31",
      },
      {
        id: "3",
        enable:1,
        code: "M003",
        category: "MC002",
        name: "painting patchwork",
        price: "12,500.00",
        unit: "l",
        createdBy: "Admin 01",
        createdDate: "2025/01/01",
      },
  ];